import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import { Container, Row, Col } from "react-bootstrap";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-medium-image-zoom/dist/styles.css";
import debounce from "lodash/debounce";
import Footer from "./Footer";

function Mycart() {
  const navigate = useNavigate();
  let token = localStorage.getItem("token");
  const order_count = localStorage.getItem("dealer_price_set_new");
  let local_order_id = localStorage.getItem("local_order_id");
  let server_url = localStorage.getItem("server_url");
  let dealer_id = localStorage.getItem("dealer_id");

  // Responsive state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const inputRefs = useRef({});
  const [rotation, setRotation] = useState(0);
  const [orderDescription, setOrderDescription] = useState("");
  const [mycart, setMycart] = useState([]);
  const [amount, setAmount] = useState([]);
  const [igst, setIgst] = useState([]);
  const [cgst, setCgst] = useState([]);
  const [sgst, setSgst] = useState([]);
  const [finalTotal, setFinalTotal] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [cartEmpty, setCartEmpty] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [dealer, setDealer] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [quantityInputs, setQuantityInputs] = useState({});
  const [deletedProducts, setDeletedProducts] = useState(new Set());
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isQuantityUpdating, setIsQuantityUpdating] = useState(new Map());

  const openDeleteModal = (productId) => {
    setSelectedProductId(productId);
    setShowDeleteModal(true);
  };

  const updateLocalCart = useCallback(() => {
    const localCart = localStorage.getItem("local_cart");
    let updatedCart = localCart ? JSON.parse(localCart) : [];

    updatedCart = updatedCart.map((item) => {
      const cartItem = mycart.find(
        (cart) => cart.product_id === item.product_id,
      );
      if (cartItem) {
        return { ...item, product_quantity: cartItem.product_quantity };
      }
      return item;
    });

    updatedCart = updatedCart.filter((item) =>
      mycart.some((cart) => cart.product_id === item.product_id),
    );

    mycart.forEach((cartItem) => {
      if (
        !updatedCart.some((item) => item.product_id === cartItem.product_id)
      ) {
        updatedCart.push({
          ...cartItem,
          product_id: cartItem.product_id,
          product_quantity: cartItem.product_quantity,
          product_image: cartItem.product_image,
          product_design_name: cartItem.product_design_name,
          product_dealer_price: cartItem.product_dealer_price,
          product_mrp: cartItem.product_mrp,
          size_name: cartItem.size_name,
          product_piece_per_box: cartItem.product_piece_per_box,
        });
      }
    });

    localStorage.setItem("local_cart", JSON.stringify(updatedCart));
  }, [mycart]);

  const getOrders = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      const res = await axios.post(`${server_url}my_cart.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setMycart(res.data.result);
        setAmount(res.data.totalAmount);
        setIgst(res.data.order_igst);
        setCgst(res.data.order_cgst);
        setSgst(res.data.order_sgst);
        setFinalTotal(res.data.order_final_total_with_gst);
        setCartEmpty(false);
        const initialQuantities = res.data.result.reduce(
          (acc, item) => ({
            ...acc,
            [item.cart_product_id]: item.product_quantity,
          }),
          {},
        );
        setQuantityInputs(initialQuantities);
        updateLocalCart();
      } else {
        setOrderPlaced(true);
        setCartEmpty(true);
        localStorage.setItem("local_cart", JSON.stringify([]));
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setIsInitialLoading(false);
    }
  }, [dealer_id, server_url, updateLocalCart]);

  const checkUser = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("device_token", token);
      const res = await axios.post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        localStorage.setItem(
          "local_overdue_amount",
          res.data.result[0].overdue_amount,
        );
        localStorage.setItem("local_dealer_os", res.data.result[0].dealer_os);
        localStorage.setItem("order_date", res.data.result[0].order_date);
        localStorage.setItem(
          "local_items_in_cart",
          res.data.result[0].items_in_cart,
        );
        localStorage.setItem(
          "local_current_order_status",
          res.data.result[0].current_order_status,
        );
        localStorage.setItem(
          "local_order_final_total_with_gst",
          res.data.result[0].order_final_total_with_gst,
        );
        localStorage.setItem("local_order_id", res.data.result[0].order_id);
        localStorage.setItem(
          "local_dealer_firm_name",
          res.data.result[0].dealer_firm_name,
        );
      }
    } catch (e) {
      console.error("Error checking user:", e);
    }
  }, [dealer_id, token, server_url]);

  useEffect(() => {
    checkUser();
    const timer = setTimeout(() => {
      getOrders();
    }, 3000);
    return () => clearTimeout(timer);
  }, [checkUser, getOrders]);

  const addOrder = useCallback(async () => {
    if (!dealer_id) {
      navigate("/Logout");
      return;
    }
    setOrderPlaced(true);
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("depo_id", "");
      formData.append("order_description", orderDescription);
      const response = await axios.post(
        `${server_url}add_order.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      setShowOrderModal(false);
      if (response.data.status === "1") {
        localStorage.setItem("local_cart", JSON.stringify([]));
        navigate(`/MyOrderds`);
      } else {
        toast(response.data.error || "Please Try After Some Time.");
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    } finally {
      setOrderPlaced(false);
    }
  }, [dealer_id, navigate, orderDescription, server_url]);

  const deleteCart = useCallback(
    async (selectedProduct) => {
      if (!dealer_id) {
        navigate("/Logout");
        return;
      }
      if (!selectedProduct) {
        toast("Please select product");
        return;
      }
      setDeletedProducts((prev) => new Set(prev).add(selectedProduct));
      try {
        const formData = new FormData();
        formData.append("company_id", "2");
        formData.append("dealer_id", dealer_id);
        formData.append("product_id", selectedProduct);
        formData.append("qty", 0);
        const response = await axios.post(
          `${server_url}add_cart.php`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        setShowDeleteModal(false);
        if (response.data.status === "1") {
          setMycart((prev) =>
            prev.filter((item) => item.cart_product_id !== selectedProduct),
          );
          setQuantityInputs((prev) => {
            const { [selectedProduct]: _, ...rest } = prev;
            return rest;
          });
          getOrders();
        } else {
          toast(response.data.error || "Please Try After Some Time.");
        }
      } catch (e) {
        toast("Please Try After Some Time.");
      }
    },
    [dealer_id, navigate, server_url, getOrders],
  );

  const addToCart = useCallback(
    async (productId, qty, isInput = false) => {
      if (!dealer_id) {
        navigate("/Logout");
        return;
      }
      if (!productId) {
        toast("Please select product");
        return;
      }
      if (qty < 0 || isNaN(qty)) {
        toast("Invalid quantity");
        setQuantityInputs((prev) => ({
          ...prev,
          [productId]:
            mycart.find((item) => item.cart_product_id === productId)
              ?.product_quantity || 0,
        }));
        return;
      }
      setIsQuantityUpdating((prev) => new Map(prev).set(productId, true));
      try {
        const formData = new FormData();
        formData.append("company_id", "2");
        formData.append("dealer_id", dealer_id);
        formData.append("product_id", productId);
        formData.append("qty", qty);
        const response = await axios.post(
          `${server_url}add_cart.php`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        if (response.data.status === "1") {
          setMycart((prev) =>
            prev.map((item) =>
              item.cart_product_id === productId
                ? { ...item, product_quantity: qty }
                : item,
            ),
          );
          getOrders();
          if (!isInput) {
            setQuantityInputs((prev) => ({ ...prev, [productId]: qty }));
          }
        } else {
          toast(response.data.error || "Failed to update cart.");
          setDealer(response.data.result || []);
          setAlertMessage(response.data.error || "");
          setShowAlert(true);
          setQuantityInputs((prev) => ({
            ...prev,
            [productId]:
              mycart.find((item) => item.cart_product_id === productId)
                ?.product_quantity || 0,
          }));
        }
      } catch (error) {
        toast("Please Try After Some Time.");
        setQuantityInputs((prev) => ({
          ...prev,
          [productId]:
            mycart.find((item) => item.cart_product_id === productId)
              ?.product_quantity || 0,
        }));
      } finally {
        setIsQuantityUpdating((prev) => {
          const newMap = new Map(prev);
          newMap.delete(productId);
          return newMap;
        });
      }
    },
    [dealer_id, navigate, server_url, mycart, getOrders],
  );

  const debouncedAddToCartInput = useCallback(
    debounce((productId, qty) => addToCart(productId, qty, true), 500),
    [addToCart],
  );

  const debouncedAddToCartButton = useCallback(
    debounce((productId, qty) => addToCart(productId, qty, false), 300),
    [addToCart],
  );

  const handleQuantityChange = (productId, value) => {
    setQuantityInputs((prev) => ({ ...prev, [productId]: value }));
    const qty = parseInt(value, 10);
    if (!isNaN(qty) && qty >= 0 && qty <= 99) {
      debouncedAddToCartInput(productId, qty);
    } else if (value === "") {
      setQuantityInputs((prev) => ({ ...prev, [productId]: "" }));
    } else {
      toast("Quantity must be between 0 and 99");
      setQuantityInputs((prev) => ({
        ...prev,
        [productId]:
          mycart.find((item) => item.cart_product_id === productId)
            ?.product_quantity || 0,
      }));
    }
  };

  const handleButtonHold = useCallback(
    (productId, action) => {
      let intervalId;
      let timeoutId = setTimeout(() => {
        intervalId = setInterval(() => {
          setQuantityInputs((prev) => {
            const currentCartItem = mycart.find(
              (item) => item.cart_product_id === productId,
            );
            const currentQty = parseInt(
              prev[productId] ?? currentCartItem?.product_quantity ?? 0,
              10,
            );
            const newQty =
              action === "increment"
                ? Math.min(currentQty + 1, 99)
                : Math.max(currentQty - 1, 0);
            debouncedAddToCartButton(productId, newQty);
            return { ...prev, [productId]: newQty };
          });
        }, 200);
      }, 500);

      const stopAction = () => {
        clearTimeout(timeoutId);
        clearInterval(intervalId);
        document.removeEventListener("mouseup", stopAction);
        document.removeEventListener("touchend", stopAction);
      };

      document.addEventListener("mouseup", stopAction);
      document.addEventListener("touchend", stopAction);
    },
    [debouncedAddToCartButton, mycart],
  );

  const handleButtonClick = useCallback(
    (productId, action) => {
      setQuantityInputs((prev) => {
        const currentCartItem = mycart.find(
          (item) => item.cart_product_id === productId,
        );
        const currentQty = parseInt(
          prev[productId] ?? currentCartItem?.product_quantity ?? 0,
          10,
        );
        const newQty =
          action === "increment"
            ? Math.min(currentQty + 1, 99)
            : Math.max(currentQty - 1, 0);
        debouncedAddToCartButton(productId, newQty);
        return { ...prev, [productId]: newQty };
      });
    },
    [debouncedAddToCartButton, mycart],
  );

  const SkeletonCard = () => (
    <Col xs={12} sm={6} md={4} lg={3} className="mb-3">
      <div className="skeleton-card">
        <div className="skeleton-image"></div>
        <div className="skeleton-content">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
          <div className="skeleton-price-section">
            <div className="skeleton-price"></div>
            <div className="skeleton-stepper"></div>
          </div>
        </div>
      </div>
    </Col>
  );

  return (
    <>
      <Header />
      <div className="cart-page" style={{ paddingTop: isMobile ? "60px" : "" }}>
        <Container fluid className="px-3 px-md-4 py-3">
          {isInitialLoading ? (
            <Row>
              {Array.from({ length: 4 }).map((_, index) => (
                <SkeletonCard key={index} />
              ))}
            </Row>
          ) : !cartEmpty ? (
            <>
              <Row className="g-3 mb-4">
                {mycart.map((data) => (
                  <Col xs={12} sm={6} md={4} lg={3} key={data.cart_product_id}>
                    <div className="cart-card">
                      <Link
                        to={`/ProductDetails/${data.product_id}`}
                        className="image-link"
                      >
                        <img
                          src={data.product_image}
                          alt={data.product_design_name}
                          className="cart-image"
                          onClick={() => {
                            setSelectedImage(data.product_image);
                            setRotation(0);
                          }}
                        />
                      </Link>
                      {data.Product_discount_per && order_count === "1" && (
                        <span className="discount-badge">
                          {data.Product_discount_per} OFF
                        </span>
                      )}
                      <div className="card-content">
                        <h4 className="product-title">
                          {data.product_design_name}
                        </h4>
                        <p className="product-details">
                          Size: {data.size_name}{" "}
                          <span className="pack-info">
                            (Pack of {data.product_piece_per_box})
                          </span>
                        </p>
                        {order_count === "1" && (
                          <div className="price-section">
                            {data.product_dealer_price !== data.product_mrp && (
                              <span className="mrp">{data.product_mrp}</span>
                            )}
                            <span className="dealer-price">
                              {data.product_dealer_price}
                            </span>
                          </div>
                        )}
                        <div className="quantity-section" style={{    background:' rgba(255, 255, 255, 0.9)'}}>
                          <div className="stepper">
                            <button
                              className="step-btn decrement"
                              onClick={() =>
                                handleButtonClick(
                                  data.cart_product_id,
                                  "decrement",
                                )
                              }
                              onMouseDown={() =>
                                handleButtonHold(
                                  data.cart_product_id,
                                  "decrement",
                                )
                              }
                              onTouchStart={() =>
                                handleButtonHold(
                                  data.cart_product_id,
                                  "decrement",
                                )
                              }
                            >
                              <i className="fa fa-minus redcolor"></i>
                            </button>
                            <input
                              type="number"
                              min="0"
                              max="99"
                              value={
                                quantityInputs[data.cart_product_id] ??
                                data.product_quantity
                              }
                              onChange={(e) =>
                                handleQuantityChange(
                                  data.cart_product_id,
                                  e.target.value,
                                )
                              }
                              className="quantity-input"
                            />
                            <button
                              className="step-btn increment"
                              onClick={() =>
                                handleButtonClick(
                                  data.cart_product_id,
                                  "increment",
                                )
                              }
                              onMouseDown={() =>
                                handleButtonHold(
                                  data.cart_product_id,
                                  "increment",
                                )
                              }
                              onTouchStart={() =>
                                handleButtonHold(
                                  data.cart_product_id,
                                  "increment",
                                )
                              }
                            >
                              <i className="fa fa-plus redcolor"></i>
                            </button>
                          </div>
                          <button
                            className="delete-btn"
                            onClick={() =>
                              openDeleteModal(data.cart_product_id)
                            }
                          >
                            <i className="fa fa-trash white"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className="summary-section">
                <h5 className="items-count">
                  Total {mycart.length} {mycart.length === 1 ? "Item" : "Items"}{" "}
                  in your cart
                </h5>
                <textarea
                  className="remark-input"
                  placeholder="Remark"
                  value={orderDescription}
                  onChange={(e) => setOrderDescription(e.target.value)}
                ></textarea>
                {order_count === "1" && (
                  <div className="totals-card">
                    <table className="totals-table">
                      <tbody>
                        <tr>
                          <td>Sub Total:</td>
                          <td>{amount}</td>
                        </tr>
                        {igst > 0 ? (
                          <tr>
                            <td>IGST:</td>
                            <td>{igst}</td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <td>CGST:</td>
                              <td>{cgst}</td>
                            </tr>
                            <tr>
                              <td>SGST:</td>
                              <td>{sgst}</td>
                            </tr>
                          </>
                        )}
                        <tr className="total-row">
                          <td>Final Total:</td>
                          <td>{finalTotal}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className="fixed-bottom-bar">
                {local_order_id && local_order_id.length > 0 ? (
                  <button
                    className="place-order-btn"
                    onClick={() => setShowOrderModal(true)}
                    disabled={orderPlaced || isQuantityUpdating.size > 0}
                  >
                    <i className="fa fa-shopping-cart white"></i> Place Order
                  </button>
                ) : (
                  <Link
                    to={`/Checkuser/${encodeURIComponent(orderDescription)}`}
                    className="submit-btn"
                  >
                    <i className="fa fa-shopping-cart white"></i> Submit
                  </Link>
                )}
              </div>
            </>
          ) : (
            <div className="empty-cart">
              <div className="empty-content">
                <h2>Oops! You don't have any selection yet.</h2>
                <Link to="/AddProduct" className="explore-btn">
                  Explore Products
                </Link>
              </div>
            </div>
          )}
        </Container>

        {isMobile && (
          <>
            <br />
            <br />
          </>
        )}

        {/* Modals - unchanged but with responsive adjustments */}
        {showAlert && (
          <div className="modal-overlay">
            <div className="modal-content alert-modal">
              <div className="modal-body">
                {dealer.map((dealerItem) => (
                  <p key={dealerItem.dealer_id} className="alert-text">
                    <i className="fa fa-exclamation-triangle white"></i>{" "}
                    {alertMessage}
                    <br />
                    {dealerItem.dealer_firm_name &&
                      `Name: ${dealerItem.dealer_firm_name}`}
                    <br />
                    {dealerItem.dealer_login_mobile &&
                      `Number: ${dealerItem.dealer_login_mobile}`}
                    <br />
                    {dealerItem.dealer_address &&
                      `Address: ${dealerItem.dealer_address}`}
                  </p>
                ))}
                <button
                  className="btn btn-danger modal-btn"
                  onClick={() => setShowAlert(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {showOrderModal && (
          <div className="modal-overlay">
            <div className="modal-content confirm-modal">
              <div className="modal-header">
                <h5>Confirm Order</h5>
                <button
                  className="close-btn"
                  onClick={() => setShowOrderModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <p style={{ marginBottom: "0px" }}>
                  Are you sure you want to place the order?
                </p>
              </div>
              {!orderPlaced && (
                <div className="modal-footer">
                  <button
                    className="btn btn-danger modal-btn"
                    onClick={() => setShowOrderModal(false)}
                  >
                    No
                  </button>
                  <button
                    className="btn btn-primary modal-btn"
                    onClick={addOrder}
                  >
                    Yes
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="modal-overlay">
            <div className="modal-content confirm-modal">
              <div className="modal-header">
                <h5>Remove Item</h5>
                <button
                  className="close-btn"
                  onClick={() => setShowDeleteModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <p style={{ marginBottom: "0px" }}>
                  Are you sure you want to remove this item from the cart?
                </p>
              </div>
              {!deletedProducts.has(selectedProductId) && (
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary modal-btn"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    No
                  </button>
                  <button
                    className="btn btn-danger modal-btn"
                    onClick={() => deleteCart(selectedProductId)}
                  >
                    Yes
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {selectedImage && (
          <div className="image-modal-overlay">
            <div className="image-modal-content">
              <TransformWrapper
                initialScale={1}
                minScale={0.5}
                maxScale={15}
                panning={true}
                wheel={true}
              >
                <TransformComponent>
                  <img
                    src={selectedImage}
                    alt="Zoomed"
                    className="zoomed-image"
                    style={{ transform: `rotate(${rotation}deg)` }}
                  />
                </TransformComponent>
              </TransformWrapper>
              <div className="image-modal-controls">
                <button
                  className="rotate-btn left"
                  onClick={() => setRotation((prev) => prev - 90)}
                >
                  ↺
                </button>
                <button
                  className="rotate-btn right"
                  onClick={() => setRotation((prev) => prev + 90)}
                >
                  ↻
                </button>
                <button
                  className="close-image-btn"
                  onClick={() => setSelectedImage(null)}
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .cart-page {
          background: #ffffff;
          min-height: 100vh;
          color: #000000;
          font-family:
            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        /* Product Cards */
        .cart-card {
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
          transition: all 0.3s ease;
          height: 96%;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .cart-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          border-color: #db4437;
        }

        .image-link {
          position: relative;
          display: block;
          aspect-ratio: 4/3;
          overflow: hidden;
          height: 402px;
          border-radius: 10px;
          width: 100%;
          border: 1px solid #f0f0f0;
        }

        .card-content {
          width: 100%;
        }

        .cart-image {
          width: 100%;
          height: 100%;
          object-fit: fill;
          transition: transform 0.3s ease;
        }

        .image-link:hover .cart-image {
          transform: scale(1.05);
        }

        .discount-badge {
          position: absolute;
          top: 8px;
          left: 8px;
          background: #db4437;
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 1;
        }

        .card-content {
          padding: 12px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .product-title {
          font-size: large;
          font-weight: 600;
          color: #000000;
          margin-bottom: 8px;
          line-height: 1.3;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .product-details {
          color: #333333;
          margin-bottom: 12px;
        }

        .pack-info {
          float: right;
          opacity: 0.8;
          color: #666666;
        }

        .price-section {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 12px;
        }

        .mrp {
          font-size: 0.85rem;
          text-decoration: line-through;
          color: #999999;
        }

        .dealer-price {
          font-size: 1rem;
          font-weight: 700;
          color: #10b981;
        }

        .quantity-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .stepper {
          display: flex;
          align-items: center;
          border-radius: 8px;
          padding: 4px;
          gap: 4px;
        }

        .step-btn {
          width: 28px;
          height: 28px;
          border: none;
          background: transparent;
          color: #ffffff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          transition: background 0.2s ease;
        }

        .step-btn:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .quantity-input {
          width: 40px;
          text-align: center;
          background: transparent;
          border: none;
          color: #ffffff;
          font-size: 0.9rem;
        }

        .quantity-input:focus {
          outline: none;
        }

        .delete-btn {
          background: #ef4444;
          border: none;
          color: white;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease;
        }

        .delete-btn:hover {
          background: #dc2626;
        }

        /* Summary Section */
        .items-count {
          font-weight: 600;
          color: #000000;
          margin-bottom: 12px;
        }

        .remark-input {
          width: 100%;
          background: #ffffff;
          border: 1px solid #e5e5e5;
          color: #000000;
          border-radius: 8px;
          padding: 12px;
          resize: vertical;
          min-height: 80px;
          margin-bottom: 16px;
        }

        .remark-input::placeholder {
          color: #999999;
        }

        .remark-input:focus {
          border-color: #db4437;
          outline: none;
        }

        .totals-card {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 12px;
          border: 1px solid #e5e5e5;
        }

        .totals-table {
          width: 100%;
          color: #000000;
        }

        .totals-table td {
          padding: 8px 0;
          font-size: 0.95rem;
        }

        .totals-table td:first-child {
          font-weight: 600;
        }

        .total-row {
          border-top: 1px solid #dddddd;
          font-size: 1.1rem;
        }

        .total-row td:last-child {
          font-weight: 700;
          color: #10b981;
        }

        .place-order-btn,
        .submit-btn {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          font-weight: 600;
          text-align: center;
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .place-order-btn {
          background: #000000;
          color: #ffffff;
          border: 1px solid #000000;
        }

        .place-order-btn:hover:not(:disabled),
        .submit-btn:hover {
          background: #db4437;
          color: #ffffff;
          transform: translateY(-1px);
          border-color: #db4437;
        }

        .place-order-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .submit-btn {
          background: #ef4444;
          color: #ffffff;
          border: 1px solid #ef4444;
        }

        /* Empty State */
        .empty-cart {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: calc(100vh - 200px);
        }

        .empty-content {
          background: #ffffff;
          border-radius: 16px;
          padding: 32px 24px;
          text-align: center;
          border: 1px solid #e5e5e5;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .empty-content h2 {
          color: #000000;
          font-size: 1.25rem;
          margin-bottom: 16px;
          font-weight: 600;
        }

        .explore-btn {
          background: #000000;
          color: #ffffff;
          padding: 12px 24px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          display: inline-block;
          transition: all 0.3s ease;
          border: 1px solid #000000;
        }

        .explore-btn:hover {
          background: #db4437;
          border-color: #db4437;
        }

        /* Skeleton */
        .skeleton-card {
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e5e5e5;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .skeleton-image {
          height: 150px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #f8f8f8 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
        }

        .skeleton-content {
          padding: 12px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .skeleton-title,
        .skeleton-subtitle,
        .skeleton-price {
          height: 16px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #f8f8f8 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 8px;
        }

        .skeleton-subtitle {
          width: 60%;
          height: 14px;
        }

        .skeleton-price-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .skeleton-stepper {
          display: flex;
          align-items: center;
          gap: 4px;
          width: 80px;
          height: 28px;
          background: #000000;
          border-radius: 8px;
          padding: 4px;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Modals */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
          padding: 20px;
        }

        .modal-content {
          background: #ffffff;
          border-radius: 12px;
          max-width: 400px;
          width: 100%;
          max-height: 80vh;
          overflow-y: auto;
          border: 1px solid #e5e5e5;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        }

        .alert-modal .modal-body,
        .confirm-modal .modal-body {
          padding: 20px;
          text-align: center;
        }

        .alert-text {
          color: #000000;
          font-size: 0.95rem;
          line-height: 1.5;
          margin-bottom: 16px;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 20px;
          border-bottom: 1px solid #e5e5e5;
        }

        .modal-header h5 {
          margin: 0;
          color: #000000;
        }

        .close-btn {
          background: none;
          border: none;
          color: #000000;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-btn:hover {
          color: #db4437;
        }

        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          padding: 16px 20px;
          border-top: 1px solid #e5e5e5;
        }

        .modal-btn {
          padding: 8px 16px;
          border-radius: 6px;
          font-size: larger;
          transition: background 0.2s ease;
        }

        /* Image Modal */
        .image-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
          padding: 20px;
        }

        .image-modal-content {
          position: relative;
          width: 100%;
          height: 100%;
          max-width: 90vw;
          max-height: 90vh;
        }

        .zoomed-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 8px;
          transition: transform 0.3s ease;
        }

        .image-modal-controls {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 10px;
        }

        .rotate-btn,
        .close-image-btn {
          background: rgba(0, 0, 0, 0.7);
          border: none;
          color: #ffffff;
          padding: 8px 12px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 1rem;
          transition: background 0.2s ease;
        }

        .rotate-btn:hover,
        .close-image-btn:hover {
          background: rgba(219, 68, 55, 0.8);
        }

        .close-image-btn {
          position: absolute;
          top: 20px;
          right: 20px;
          bottom: auto;
          left: auto;
          transform: none;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .cart-image {
            aspect-ratio: 1/1;
          }

          .image-link {
            width: 50%;
            height: 232px;
          }

          .card-content {
            width: 50%;
            justify-content: center;
          }

          .cart-card {
            display: -webkit-box;
          }

          .pack-info {
            float: left;
            opacity: 0.8;
            color: #666666;
          }

          .product-title {
            font-size: large;
          }

          .dealer-price {
            font-size: 0.95rem;
          }

          .step-btn {
            width: 24px;
            height: 24px;
          }

          .quantity-input {
            width: 32px;
            font-size: 0.85rem;
          }

          .delete-btn {
            width: 28px;
            height: 28px;
          }

          .totals-table td {
            font-size: 0.9rem;
            padding: 6px 0;
          }

          .place-order-btn,
          .submit-btn {
            padding: 10px;
            font-size: 0.95rem;
          }

          .empty-content {
            padding: 24px 16px;
          }

          .empty-content h2 {
            font-size: 1.1rem;
          }

          .image-modal-controls {
            bottom: 10px;
          }

          .rotate-btn,
          .close-image-btn {
            padding: 6px 10px;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .cart-card {
            margin-bottom: 12px;
          }

          .stepper {
            justify-content: center;
          }

          .delete-btn {
            align-self: center;
          }
        }

        /* Touch Optimizations */
        @media (hover: none) and (pointer: coarse) {
          .cart-card:hover,
          .step-btn:hover,
          .delete-btn:hover {
            transform: none;
          }
        }

        .redcolor {
          color: rgb(219, 68, 55) !important;
        }
        .white {
          color: white !important;
        }
          .stepper input{
           color: rgb(0, 0, 0) !important;
          }
      `}</style>

      {/* <Footer /> */}
    </>
  );
}

export default Mycart;
